import {IQuestion, QuestionReference} from '../../../model/Question';
import {IAnswer} from "../../../model/Answer";
import {
  GeneralQuestions01,
  GeneralQuestions02,
  GeneralQuestions03,
  GeneralQuestions04,
  GeneralQuestions05,
  GeneralQuestions06,
  GeneralQuestions07,
  GeneralQuestions08,
  GeneralQuestions09,
  GeneralQuestions10,
  GeneralQuestions11,
  GeneralQuestions12,
  GeneralQuestions13,
  GeneralQuestions14,
  GeneralQuestions15
} from "./AccessibilityQuestions";


/**
 * will *eventually* encapsulate a set of questions and their associated answers
 */
export class QuestionAnswerSet {

  public questions: QuestionReference[] = [];


  calculateScore(): number {

    let answer = 0;
    answer += this.calculateScoreAcrossQuestions();
    return answer;
  }


  calculateScoreAcrossQuestions: () => number = () => 0;


  constructor( public questionValues: IQuestion[],
               public answerValues: { [key: string]: IAnswer; } ) {

    this.questions = questionValues.map( (e) => new QuestionReference( e ));
  }

}





export class General {


  /**
   * @deprecated use 'GeneralQuestions02.QUESTION_VALUES'
   */
  static readonly QUESTIONS_2: IQuestion[] = GeneralQuestions02.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions03.QUESTION_VALUES'
   */
  static readonly QUESTIONS_3: IQuestion[] = GeneralQuestions03.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions04.QUESTION_VALUES'
   */
  static readonly QUESTIONS_4: IQuestion[] = GeneralQuestions04.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions05.QUESTION_VALUES'
   */
  static readonly QUESTIONS_5: IQuestion[] = GeneralQuestions05.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions06.QUESTION_VALUES'
   */
  static readonly QUESTIONS_6: IQuestion[] = GeneralQuestions06.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions07.QUESTION_VALUES'
   */
  static readonly QUESTION_SET07_VALUES: IQuestion[] = GeneralQuestions07.QUESTION_VALUES;

  /**
   * @deprecated use `GeneralQuestions07.QUESTIONS`
   */
  static readonly QUESTION_SET07: QuestionReference[] = GeneralQuestions07.QUESTIONS;

  /**
   * @deprecated use 'GeneralQuestions08.QUESTION_VALUES'
   */
  static readonly QUESTIONS_8: IQuestion[] = GeneralQuestions08.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions09.QUESTION_VALUES'
   */
  static readonly QUESTIONS_9: IQuestion[] = GeneralQuestions09.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions10.QUESTION_VALUES'
   */
  static readonly QUESTIONS_10: IQuestion[] = GeneralQuestions10.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions11.QUESTION_VALUES'
   */
  static readonly QUESTION_SET11_VALUES: IQuestion[] = GeneralQuestions11.QUESTION_VALUES;

  /**
   * @deprecated use 'GeneralQuestions11.QUESTIONS'
   */
  static readonly QUESTION_SET11: QuestionReference[] = GeneralQuestions11.QUESTIONS;

  /**
   * @deprecated use `GeneralQuestions12.QUESTIONS`
   */
  static readonly QUESTION_SET12: QuestionReference[] = GeneralQuestions12.QUESTIONS;

  /**
   * @deprecated use 'GeneralQuestions15.QUESTION_VALUES'
   */
  static readonly QUESTION_SET15_VALUES: IQuestion[] = GeneralQuestions15.QUESTION_VALUES;


  public static readonly ALL_QUESTION_VALUES_SETS: IQuestion[][] = [
    GeneralQuestions01.QUESTION_VALUES,
    GeneralQuestions02.QUESTION_VALUES,
    GeneralQuestions03.QUESTION_VALUES,
    GeneralQuestions04.QUESTION_VALUES,
    GeneralQuestions05.QUESTION_VALUES,
    GeneralQuestions06.QUESTION_VALUES,
    GeneralQuestions07.QUESTION_VALUES,
    GeneralQuestions08.QUESTION_VALUES,
    GeneralQuestions09.QUESTION_VALUES,
    GeneralQuestions10.QUESTION_VALUES,
    GeneralQuestions11.QUESTION_VALUES,
    GeneralQuestions12.QUESTION_VALUES,
    GeneralQuestions13.QUESTION_VALUES,
    GeneralQuestions14.QUESTION_VALUES,
    GeneralQuestions15.QUESTION_VALUES,
  ];



  private static _QUESTIONS_ALL: IQuestion[] = null;

  public static getAllQuestionValues(): IQuestion[] {

    if ( null !== General._QUESTIONS_ALL ) {

      return General._QUESTIONS_ALL;
    }


    this._QUESTIONS_ALL = [];

    for ( const questionSet of General.ALL_QUESTION_VALUES_SETS ) {
      for ( const question of questionSet ) {

        this._QUESTIONS_ALL.push( question );
      }
    }

    return General._QUESTIONS_ALL;

  }


  static calculateScoreAcrossQuestions( answerValues: { [key: string]: IAnswer; } ): number {
    let answer = 0;

    answer += GeneralQuestions01.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions02.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions03.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions04.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions05.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions06.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions07.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions08.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions09.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions10.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions11.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions12.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions13.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions14.calculateScoreAcrossQuestions( answerValues );
    answer += GeneralQuestions15.calculateScoreAcrossQuestions( answerValues );

    return answer;
  }


  }
